import request from '@/utils/request'


export function getSchoolMajors() {
  return request({
    url: '/common/getmajorsschools',
    method: 'get',
  })
}


export function getCourses() {
  return request({
    url: '/common/getcourselist',
    method: 'get',
  })
}
